import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVersusCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVersusCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.6 8.1H17.4V10.5H15.6V9.9H14.4V11.1H17.4V15.9H12.6V13.5H14.4V14.1H15.6V12.9H12.6V8.1ZM7.9 8.09961V12.7565L8.6836 14.0998H8.8164L9.6 12.7565V8.09961H11.4V13.2431L9.85027 15.8998H7.64973L6.1 13.2431V8.09961H7.9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVersusCircle;
